module.exports = __webpack_public_path__ + "static/mobile-original-88df63228a002cc532ba92b8506baf21.png";